import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

export default class ProductInfoTagService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/productInfoTag'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/productInfoTag', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/productInfoTag/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/productInfoTag/${id}`)
    }

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  calcuateUsedTimes (productInfoTagList, articleList) {
    var tagIDUsedTimes = {}
    var i
    var id
    for (i = articleList.length - 1; i >= 0; --i) {
      for (let lang of config.languages) {
        if (!articleList[i][lang]) continue
        let tags = articleList[i][lang].Tags
        let tagIDArr = tags.map(o => o.ID)

        for (id of tagIDArr) {
          if (!tagIDUsedTimes[id]) tagIDUsedTimes[id] = 0
          ++tagIDUsedTimes[id]
        }
      }
    }
    let tagIDArr = Object.keys(tagIDUsedTimes)
    for (i = tagIDArr.length - 1; i >= 0; --i) {
      let tagID = tagIDArr[i]
      let usedTimes = tagIDUsedTimes[tagID]
      let productInfoTag = (productInfoTagList.find(o => o.ID === tagID) || {})
      productInfoTag.usedTimes = usedTimes
    }
  }
  findCommonlyUsedList (productInfoTagList) {
    const N = 15
    // 找出前n個常用標籤 的數字
    let sortedUsedTimesArr = productInfoTagList.map(o => o.usedTimes || 0).sort((o1, o2) => o2 - o1)
    let minUsedTimes = sortedUsedTimesArr[Math.min(sortedUsedTimesArr.length, N) - 1]
    // 找出常用標籤並排序
    let commonlyUsedTagList = productInfoTagList
      .filter(o => (o.usedTimes || 0) >= minUsedTimes)
      .sort((o1, o2) => (o2.usedTimes || 0) - (o1.usedTimes || 0))
    return commonlyUsedTagList
  }
}
